import { render } from "./ModalCGU.vue?vue&type=template&id=760c338e&scoped=true&ts=true"
import script from "./ModalCGU.vue?vue&type=script&lang=ts"
export * from "./ModalCGU.vue?vue&type=script&lang=ts"

import "./ModalCGU.vue?vue&type=style&index=0&id=760c338e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760c338e"]])

export default __exports__